import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { LovComponent } from 'src/app/lov/lov.component';
import { MatDialog } from '@angular/material';
import { RepserviceService } from '../_service/repservice.service';

@Component( {
  selector: 'app-mktgp006',
  templateUrl: './mktgp006.component.html',
  styleUrls: ['./mktgp006.component.css']
} )
/** mktgp006 component*/
export class Mktgp006Component implements OnInit
{
  /** mktgp006 ctor */

  @ViewChild( 'lovCost' ) lovCost;
  @ViewChild( 'inputhike' ) inputhike;
  lovPost: any[] = [];
  repform: FormGroup;
  submitted = false;
  id: string; qid: string; wherecols: string; lovname: string; RDLC: string;
  CostCenterDesc: string; ErpStateUnit: string; CostCenterCode: string;
  apiUrl: string;
  constructor( private formBuilder: FormBuilder, public dialog: MatDialog, private _service: RepserviceService )
  {
    this.apiUrl = 'http://localhost:61201/api/ReportMaster/';
  }

  ngOnInit()
  {
    this.repform = this.formBuilder.group( {
      fromYear: ['', [Validators.required]],
      toYear: ['', [Validators.required]],
      budget: [''],
      Consol: [''],
      RType: [''],
      CostCenterDesc: [''],
      ErpStateUnit: [''],
      CostCenterCode: [''],
      RDLC: ['']
    });

    $(".loader-mn").hide();
  }

  openDialog(): void
  {
    debugger;
    this.id = this.lovCost.nativeElement.attributes.id.value;
    this.qid = this.lovCost.nativeElement.attributes.queryid.value;
    this.wherecols = this.inputhike.nativeElement.value;
    this.lovname = this.lovCost.nativeElement.attributes.lovname.value;

    this.lovPost.push( this.id, this.qid, this.wherecols, this.lovname );

    const dialogRef = this.dialog.open( LovComponent, {
      width: '800px',
      data: this.lovPost,
      disableClose: true
    } );

    dialogRef.afterClosed().subscribe( result =>
    {
      debugger;
      this.repform.value.CostCenterDesc = this.CostCenterDesc = result.COST_CENTER_DESC;
      this.repform.value.CostCenterCode = this.CostCenterCode = result.COAT_CENTER_FO;
      this.repform.value.ErpStateUnit = this.ErpStateUnit = result.STATE_CODE;

      this.lovPost = [];
    } );
  }
  changeStatus(fromYear: string, toYear: string, budget: string, RType: string, CostCenterCode: string, ErpStateUnit: string, RDLC: string, Consol: string) {
    debugger;
    if (this.repform.value.CostCenterDesc == '') {
      alert('Enter Cost centre name.');
      return;
    } else if (this.repform.value.ErpStateUnit == '') {
      alert('ERP STATE UNIT CODE IS NULL.');
      return;
    } else {

      var id = "";
      var Par = "";

      var I_FROM_YM = fromYear;
      var I_TO_YM = toYear;
      var v_sub_unit = ErpStateUnit;
      var P_UNIT = ErpStateUnit;
      var P_UNIT_CODE = ErpStateUnit;
      var IFFCO_Y_N_S = Consol;
      var I_BUD_FOR = budget;
      var reptype = RType;
      var p_org_Id = 148;

      if (RDLC != "true")
      {
         reptype="P";
      }
      if (reptype == "P") {

        id = "1302";
        Par = I_FROM_YM + '^' + I_TO_YM + '^' + v_sub_unit + '^' + P_UNIT + '^' + P_UNIT_CODE + '^' + IFFCO_Y_N_S + '^' + I_BUD_FOR + '^' + p_org_Id + '^' + '' + '^' + '' + '^' + '' + '^null';

      }
      else {
        id = "1312";
        Par = I_FROM_YM + '^' + I_TO_YM + '^' + v_sub_unit + '^' + P_UNIT + '^' + P_UNIT_CODE + '^' + IFFCO_Y_N_S + '^' + I_BUD_FOR + '^' + p_org_Id + '^' + '' + '^' + '' + '^' + '' + '^null';

      }

      this.openrep(id, Par, RDLC);
    }
  }
  onSubmit()
  {
    debugger;
    this.submitted = true;

    if ( this.repform.value.CostCenterDesc == '' )
    {
      alert( 'Enter Cost centre name.' );
      return;
    } else if ( this.repform.value.ErpStateUnit == '' )
    {
      alert( 'ERP STATE UNIT CODE IS NULL.' );
      return;
    } else
    {

      var id = "";
      var Par = "";

      var I_FROM_YM = this.repform.value.fromYear;
      var I_TO_YM = this.repform.value.toYear;
      var v_sub_unit = this.repform.value.ErpStateUnit;
      var P_UNIT = this.repform.value.ErpStateUnit;
      var P_UNIT_CODE = this.repform.value.ErpStateUnit;
      var IFFCO_Y_N_S = this.repform.value.Consol;
      var I_BUD_FOR = this.repform.value.budget;
      var reptype = this.repform.value.RType;
      var p_org_Id = 148;
      var RDLC = this.repform.value.RDLC;
      if (reptype == "P")
      {

         id = "1302";
        Par = I_FROM_YM + '^' + I_TO_YM + '^' + v_sub_unit + '^' + P_UNIT + '^' + P_UNIT_CODE + '^' + IFFCO_Y_N_S + '^' + I_BUD_FOR + '^' + p_org_Id + '^' + '' + '^' + '' + '^' + '' +  '^null';

      }
      else
      {
         id = "1312";
        Par = I_FROM_YM + '^' + I_TO_YM + '^' + v_sub_unit + '^' + P_UNIT + '^' + P_UNIT_CODE + '^' + IFFCO_Y_N_S + '^' + I_BUD_FOR + '^' + p_org_Id + '^' + '' + '^' + '' + '^' + '' +  '^null';

      }
     
      this.openrep(id, Par, RDLC);

    }
  }

  openrep(id: string, par: string, rdlc: string) {
    debugger;
    this._service.openrep(id, par, rdlc).subscribe
      (res => {
        if (res) {
          var url = JSON.parse(JSON.stringify(res));
          window.open(url.reporturl, '_blank');
        }
      });
  }
}
